/**
 * Turns a snake_case enum value into readable title case.
 * Example: 'edits_requested' -> 'Edits Requested'. Empty input -> ''.
 */
export const formatEnumLabel = (value) => {
    if (!value) return '';
    return value
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
